import { Link } from 'react-router-dom';
import { categories, brandInfo } from '@/mocks/tvshows';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 tracking-tight whitespace-nowrap">
                久播影院
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {brandInfo.slogan}
            </p>
            <p className="text-sm text-foreground-400 mt-3 leading-relaxed">
              高清电视剧免费在线观看平台，追剧不等待，精彩不间断。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              剧集分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/guochan"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  国产剧
                </Link>
              </li>
              <li>
                <Link
                  to="/category/hanju"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  韩剧
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              联系方式
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>{brandInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line text-foreground-400"></i>
                <span>微信：{brandInfo.contact.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-time-line text-foreground-400"></i>
                <span>{brandInfo.contact.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 久播影院 Jiubo Cinema. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="/about"
              className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap"
            >
              关于我们
            </a>
            <span className="text-foreground-700">|</span>
            <a
              href="/about"
              className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap"
            >
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}